const React = require('react');
const { default: Styled } = require('styled-components');
const { default: Typography } = require('@mui/material/Typography');

const { default: Classes } = require('./styles.scss');
const IsEmail = require('utils/is-email');

const MB_IN_BYTES = 1000000;

const internals = {};

internals.OrSpacer = Styled.div`
    margin: 1em 0;
    text-align: center;
`;

module.exports.buildDefaults = function buildDefaults() {

    return {
        csv: null,
        notifyUsers: false,
        roleName: '',
        userByText: ''
    };
};

module.exports.buildFields = function buildFields({
    csvValue,
    schoolName,
    schoolRoles,
    setCsvValue,
    setUserByTextValue,
    userByTextValue
} = {}) {

    return [
        {
            type: 'custom',
            key: 'school-name',
            render: () => <div className={Classes.uploadFileInstructions}>For <b>{schoolName}</b></div>
        },
        {
            type: 'instructions',
            text: 'Enter a single email address to create one new user -OR- upload a CSV file containing multiple user emails for preapproval.'
        },
        {
            type: 'instructions',
            text: 'Make sure the CSV file contains only one column with a header row named \'EMAIL\'. Please select below which user type to create.'
        },
        {
            type: 'CheckboxField',
            name: 'notifyUsers',
            label: 'Notify Users'
        },
        {
            type: 'SelectField',
            name: 'roleName',
            label: 'User type',
            required: true,
            options: [
                { value: '', label: 'Select…' },
                ...(schoolRoles || []).map((schoolRole) => ({
                    value: schoolRole.name,
                    label: schoolRole.label
                }))
            ],
            textFieldProps: {
                id: 'user-type-select-input',
                inputProps: {
                    'aria-labelledby': 'user-type-select-input-label'
                }
            }
        },
        {
            type: 'TextField',
            name: 'userByText',
            label: 'Single Email Address',
            fullWidth: true,
            onChange: (value) => {

                setUserByTextValue?.(value || '');
            },
            rules: {
                validate: (value) => {

                    if (value && !IsEmail(value)) {
                        return 'Invalid email address';
                    }

                    if (!value && !csvValue) {
                        return 'Must specify user email here or upload CSV below';
                    }

                    return true;
                }
            },
            textFieldProps: {
                id: 'user-text-input',
                inputProps: { type: 'email' },
                InputLabelProps: {
                    classes: {
                        root: Classes.textFieldInputLabelRoot
                    }
                },
                classes: {
                    root: Classes.textFieldRoot
                }
            }
        },
        {
            type: 'custom',
            key: 'or-spacer',
            render: () => <internals.OrSpacer><Typography>{'-OR-'}</Typography></internals.OrSpacer>
        },
        {
            type: 'FileField',
            name: 'csv',
            label: 'Click to Select a CSV File',
            accept: 'text/csv',
            fullWidth: true,
            disabled: !!userByTextValue,
            onChange: (value) => {

                setCsvValue?.(value || null);
            },
            rules: {
                validate: (value) => {

                    if (!value && !userByTextValue) {
                        return 'Must upload CSV here or specify user email above';
                    }

                    if (!value) {
                        return true;
                    }

                    if (!value.name.match(/\.csv$/)) {
                        return 'File must be a csv';
                    }

                    if (value.size > (4.9 * MB_IN_BYTES)) {
                        return 'csv must be under 5mb';
                    }

                    return true;
                }
            }
        }
    ];
};

module.exports.buildFormConfig = function buildFormConfig(props) {

    const {
        formId,
        onSubmit,
        schoolName,
        schoolRoles,
        title
    } = props;

    return {
        formId,
        title,
        onSubmit,
        defaults: props.defaults || module.exports.buildDefaults(),
        fields: props.fields || module.exports.buildFields({
            csvValue: props.csvValue,
            schoolName,
            schoolRoles,
            setCsvValue: props.setCsvValue,
            setUserByTextValue: props.setUserByTextValue,
            userByTextValue: props.userByTextValue
        })
    };
};

module.exports.internals = internals;
